import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, defineComponent } from 'vue'
const _hoisted_1 = {
  xmlns: 'http://www.w3.org/2000/svg',
  'xmlns:xlink': 'http://www.w3.org/1999/xlink',
  viewBox: '0 0 24 24'
}
const _hoisted_2 = /*#__PURE__*/ _createElementVNode(
  'g',
  {
    fill: 'none'
  },
  [
    /*#__PURE__*/ _createElementVNode('path', {
      d: 'M13.409 2.513a3.75 3.75 0 0 0-2.818 0l-2.19.888l9.592 3.73l3.374-1.303a1.747 1.747 0 0 0-.46-.275l-7.498-3.04zM22 7.191l-9.25 3.574v2.3A6.482 6.482 0 0 1 17.5 11c1.747 0 3.332.689 4.5 1.81V7.19zm-10.75 3.574v4.945a6.503 6.503 0 0 0-.25 1.791c0 .621.087 1.222.25 1.79v2.397a3.748 3.748 0 0 1-.659-.199l-7.498-3.04A1.75 1.75 0 0 1 2 16.827V7.192l9.25 3.574zM2.633 5.828L12 9.447l3.917-1.514l-9.543-3.71l-3.281 1.33c-.17.069-.324.162-.46.275zM17.5 23a5.5 5.5 0 1 0 0-11a5.5 5.5 0 0 0 0 11zm2.646-7.854a.5.5 0 0 1 .708.707l-4 4a.5.5 0 0 1-.708 0l-2-2a.5.5 0 0 1 .708-.707l1.646 1.647l3.646-3.647z',
      fill: 'currentColor'
    })
  ],
  -1
  /* HOISTED */
)
const _hoisted_3 = [_hoisted_2]
export default defineComponent({
  name: 'BoxCheckmark24Filled',
  render: function render(_ctx, _cache) {
    return _openBlock(), _createElementBlock('svg', _hoisted_1, _hoisted_3)
  }
})
